var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14961 13.1501L5.51815 10.0001L7.92425 12.2501L13.2177 7.30018M9.61632 6.8501H13.6996V10.6684M3.19961 18.4001C2.03981 18.4001 1.09961 17.4599 1.09961 16.3001V3.7001C1.09961 2.5403 2.03981 1.6001 3.19961 1.6001H15.7996C16.9594 1.6001 17.8996 2.5403 17.8996 3.7001V16.3001C17.8996 17.4599 16.9594 18.4001 15.7996 18.4001H3.19961Z",
    stroke: "rgba(46, 141, 251)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLead);
export default __webpack_public_path__ + "static/media/lead.1e2ce498a7c0f5374a73aec69be250c5.svg";
export { ForwardRef as ReactComponent };